
import React, { useState } from "react";
import logo from "../images/brand/logo.png";
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons'

function FrontHeader() {
  const [sidebar, setSidebar] = useState(false);
  return (
    <>
      <header className="container position-relative" style={{zIndex: '12'}}>
        <div className="d-flex align-items-center justify-content-between" style={{paddingTop: '2.5rem',paddingBottom: '2.5rem'}}>
          <div className="d-flex align-items-center">
            <Link to="/home"><img src={logo} alt="logo" className="app-logo"/></Link>
            <div className="desk-nav d-none d-md-flex ms-4">
              <Link to="/about" className="nav-btn me-4">About Us</Link>
              <Link to="/faq" className="nav-btn me-4">Faq</Link>
              <Link to="/whyus" className="nav-btn">Why us</Link>
            </div>
          </div>
          <div className="d-flex align-items-center">
            <a href="https://echotradefx.com/exchange/login.php" className="nav-btn me-4" style={{fontSize: '14px'}}>Login</a>
            <a href="https://echotradefx.com/exchange/register.php" className="myBtn bg-prime px-3 rounded-4" style={{fontSize: '14px'}}>Get Started</a>
            {!sidebar ? (
              <FontAwesomeIcon icon={faBars} className="ms-3 text-white d-md-none" style={{fontSize: '16px'}} onClick={() => setSidebar(true)} />
            ) :(
              <div className="mx-3"></div>
            )
            }
          </div>
        </div>
      </header>
      <div className={`home-sidebar ${sidebar?'active':null}`}>
        <div className="d-flex align-items-center justify-content-end mb-4">
          <FontAwesomeIcon icon={faTimes} className="text-white" style={{fontSize: '24px'}} onClick={() => setSidebar(false)}/>
        </div>
        <div className="rounded-4 p-4 bg-white">
          <Link to="/about" className="noLink text-black mb-3 d-block" style={{fontSize: '18px'}}>About us</Link>
          <Link to="/terms" className="noLink text-black mb-3 d-block" style={{fontSize: '18px'}}>Terms and conditions</Link>
          <Link to="/whyus" className="noLink text-black mb-3 d-block" style={{fontSize: '18px'}}>Why us</Link>
          <hr style={{opacity: 1, borderColor: '#cbd5e166'}}/>
          <a href="https://echotradefx.com/exchange/login.php" className="noLink text-black mb-3 d-block" style={{fontSize: '18px'}}>Log in</a>
          <a to="https://echotradefx.com/exchange/register.php" className="noLink text-black mb-3 d-block" style={{fontSize: '18px'}}>Register</a>
        </div>
      </div>
    </>
  )
}

export default FrontHeader